export default __webpack_public_path__ + "static/media/Waterfall_159x150.c247fd90.png";